import { render, staticRenderFns } from "./customer-list.component.vue?vue&type=template&id=e2453cb6&scoped=true&"
import script from "./customer-list.component.ts?vue&type=script&lang=ts&"
export * from "./customer-list.component.ts?vue&type=script&lang=ts&"
import style0 from "./customer-list.component.scss?vue&type=style&index=0&id=e2453cb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2453cb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCol,VContainer,VDataTable,VRow,VTextField,VToolbar})
